<footer class="md-footer">
  <div class="grid justify-content-center">
    <div class="lg:col-6 sm:col-12">
      <ul class="pl-0 m-0">
        <li>
          <a routerLink="{{termOfUseUrl}}">
            Terms of Use <img class="footer-icon" src="assets/images/svg-icons/arrow-up.svg">
          </a>
        </li>
        <li>
          <a routerLink="{{privacyPolicyUrl}}">
            Privacy Policy  <img class="footer-icon" src="assets/images/svg-icons/arrow-up.svg">
          </a>
        </li>
        
        <!-- <li>
          <a routerLink="{{copyRightNoticeUrl}}">
            Copyright Notice <img class="footer-icon" src="assets/images/svg-icons/arrow-up.svg">
          </a>
        </li> -->
      </ul>
    </div>
    <div class="lg:col-6 sm:col-12 text-right copyright">
      Copyright <span class="mr-1">{{getYear()}}</span> <a class="cursor-pointer" href="{{teleUrl}}" target="_blank">TeleSpecialists</a> All Rights Reserved.
    </div>
  </div>
</footer>
